<template>
  <div class="card listing-card">
    <form @submit.prevent class="needs-validation" novalidate>
      <div v-if="serverError" class="alert alert-danger" role="alert">
        {{serverError}}
      </div>
      <div class="card-body">
        <div class="label-text">
          <span v-if="!buildingActivityArea.id">Add Building/Activity Area</span>
          <span v-if="buildingActivityArea.id">Edit Building/Activity Area</span>
        </div>
        <hr>
        <div class="form-group row">
          <label for="type" class="col-lg-4 label-text">
            <span class="text-danger">*</span>Type
          </label>
          <div class="loading col-lg-5" v-if="typeOptionsLoading">
            Loading...
          </div>
          <div class="col-lg-8">
            <select v-if="!typeOptionsLoading"
                    v-validate="'required'"
                    data-vv-as="Type"
                    class="form-control"
                    name="type"
                    v-model="buildingActivityArea.typeId">
              <option value="" disabled>Select Type</option>
              <option v-for="option in typeOptions"
                      :key="option.id"
                      :value="option.id">
                {{ option.name }}
              </option>
            </select>
            <div class="invalid-feedback">{{ errors.first('type') }}</div>
          </div>
        </div>
        <div class="form-group row">
          <label for="notes" class="col-lg-4 col-form-label label-text">
            Notes
          </label>
          <div class="col-lg-8">
            <textarea data-vv-as="Notes"
                      type="textarea"
                      class="form-control"
                      name="notes"
                      v-model="buildingActivityArea.notes"
                      placeholder="Enter Notes"
                      rows="2"
                      maxlength="300" />
              <small v-if="!errors.first('notes')" class="form-text text-muted">
                Max 300 characters
              </small>
              <div class="invalid-feedback">{{ errors.first('notes') }}</div>
          </div>
        </div>
      </div>
      <div class='card-footer right-align-content'>
        <b-button :disabled="submitting" variant="danger" class="button-row-spacing"
                  v-b-modal="'cancelBuildingActivityAreaConfirmation-' + buildingActivityArea.id">
          Cancel
        </b-button>
        <b-button
          :disabled="submitting"
          @click="submitWrapper(buildingActivityArea)"
          >
          Save
        </b-button>
      </div>
    </form>
    <CancelModal
      :modalId="'cancelBuildingActivityAreaConfirmation-' + buildingActivityArea.id"
      @cancelled="cancelEdit">
    </CancelModal>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import CancelModal from '../CancelModal.vue';
import FormSubmit from '../../mixins/FormSubmit';
import { EntityModules, LookupModules } from '@/store/moduleConfig';

export default {
  name: 'BuildingActivityAreaForm',
  components: {
    CancelModal,
  },
  mixins: [FormSubmit],
  props: [
    'buildingActivityArea',
  ],
  computed: {
    ...mapState(LookupModules.BUILDING_ACTIVITY_AREA_TYPES.namespace, {
      typeOptionsLoading: state => state.loading,
    }),
    ...mapState(EntityModules.BUILDING_ACTIVITY_AREA.namespace, {
      serverError: state => state.serverError,
      submitting: state => state.submitting,
    }),
    ...mapGetters(LookupModules.BUILDING_ACTIVITY_AREA_TYPES.namespace, {
      getTypeName: 'getName',
      typeOptions: 'getActiveOptions',
    }),
  },
  methods: {
    cancelEdit() {
      this.$emit('closeForm', this.buildingActivityArea.id);
    },
    submitWrapper(entity) {
      this.onSubmit(
        entity,
        EntityModules.BUILDING_ACTIVITY_AREA.namespace,
      );
    },
  },
};
</script>
